import React, {Component, useState } from 'react';
import ReactDOM from 'react-dom';

import GrantsApplicationsList from './components/grants-applications';
import UpcomingGrants from './components/grants-upcoming';

import {Layout, SixtyFourtyLayout} from '../../layouts';
import { ViewButton } from '../../components/buttons';

import ApplicationsApi from '../../lib/applications/application-api';
import {stringToFriendlyDatetime} from "../../lib/helpers/datetime-helpers";
import Sponsors from '../../components/sponsor';

import MediaQuery from 'react-responsive';

import GrantsActivitySidebar from './components/grants-activity-sidebar';

function Welcome() {
    return (
        <div className="website-topbar__welcome">
            <p>Grants</p>
            <h3>My Applications</h3>
        </div>
    )
}

function handleApplicationName(item) {
    if (item.application) {
        switch (item.application.name) {
            case null :
                return `Application for ${item.application.grant.name}`;
            case (item.application.name) :
                return `#${item.application.name}`;
        }
    }
    else {
        return 'Application no longer exists';
    }

}

function handleAdminNames(item) {
    if (item.created_by.super_admin === 1 || item.created_by.admin === 1) {
        return item.created_by?.name.split(" ")[0]
    }
    return item.created_by?.name
}

function UpcomingGrantsContainer({ history }) {
    const [ popup, setPopup ] = useState(null);
    history = history.map(item => {
        return {
            description: item.message,
            status: item.status,
            id:  handleApplicationName(item),
            meta:  `By ${item.created_by ? handleAdminNames(item) : 'Unknown'}, ${stringToFriendlyDatetime(item.created_at)},`
        }

    });

    return (
        <>
            <MediaQuery minWidth="0px" maxWidth="390px">
                <UpcomingGrants
                    title={'Latest Application Activity'}
                    items={history}
                />
            </MediaQuery>

            <MediaQuery minWidth="1280px">
                <UpcomingGrants
                    title={'Latest Application Activity'}
                    items={history}
                />
            </MediaQuery>

            <MediaQuery minWidth="390px" maxWidth="1280px">
                { popup && popup }

                <UpcomingGrants title={'Latest Application Activity'}>
                    <ViewButton onClick={() => {
                        setPopup(<GrantsActivitySidebar setPopup={setPopup} items={history} />)
                    }}>Activity</ViewButton>
                </UpcomingGrants>
            </MediaQuery>
        </>
    )
}

class GrantsApplications extends Component {

    constructor(props) {
        super(props);

        this.state = {
            applications: [],
            history: []
        };


    }

    componentDidMount() {
        const api = new ApplicationsApi();

        api.history().then(({data}) => {

            this.setState({history: data});
        });

        api.getApplications().then((data) => {
            this.setState({applications: data})
        })
    }

    render() {
        console.log(this.state.history)
        return (
            <Layout topLeft={<Welcome/>} >
                <SixtyFourtyLayout main={<GrantsApplicationsList applications={this.state.applications}/>} sectionOne={{
                    name: 'Application Activity', component: <UpcomingGrantsContainer history={this.state.history}/>
                }}/>

                <MediaQuery maxWidth="1280px">
                    <Sponsors />
                </MediaQuery>
            </Layout>
        );
    }
}

export default GrantsApplications;

const el = document.getElementById('grants-applications');

if (el) {
    ReactDOM.render(<GrantsApplications/>, el);
}
